import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { Formik } from "formik";
import { Button, ThemeProvider } from "@mui/material";
import { CloneTheLoanTemplateResponse, LoanTemplateSpecification } from "../../models/loanTemplate.model";
import * as Yup from "yup";
import { cloneTheLoanTemplate } from "../../services/loanTemplate.service";
import { useMutation } from "react-query";
import DatePickerComponents from "../../components/datePicker/DatePickerComponents";
import { convertToLocalDateTime } from "../../utility/dateUtility";
import { toast } from "react-toastify";
import { useHistory } from "react-router";
import PriceFeildComponent from "../../components/priceFeild/priceFeildComponent";
import { CacheProvider } from "@emotion/react";
import { createTheme } from "@mui/material/styles";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";


export default function NewTemplateInfo({ data, loanTemplateId }: { data: LoanTemplateSpecification, loanTemplateId: number }) {
    
    const cacheRtl = createCache({
        key: "muirtl",
        stylisPlugins: [prefixer, rtlPlugin],
    });
    const theme = createTheme({
        direction: "rtl",
    });
    const validationSchema = Yup.object().shape({
        loanTemplateTitle: Yup.string().required("نام طرح اجباری می باشد"),
        minAmount: Yup.string().required("کف تسهیلات اجباری می باشد"),
        maxAmount: Yup.string().required("سقف تسهیلات اجباری می باشد"),
        guarantorsCount: Yup.string().required("تعداد ضامنین اجباری می باشد"),
        repaymentPowerPercentage: Yup.string().required("درصد توان پرداخت اجباری می باشد"),
        warrantyPercentage: Yup.string().required("درصد چک ضمانت اجباری می باشد"),
        realProfitPercentage: Yup.string().required("درصد سود واقعی اجباری می باشد"),
        maxLoanAmountBasedOnVehiclePricePercentage: Yup.string().required("درصد تسهیلات اجباری می باشد"),
        minAgeRestriction: Yup.string().required("کمترین سن متقاضی اجباری می باشد"),
        maxAgeRestriction: Yup.string().required("بیشترین سن اجباری می باشد"),
    });
    const [expirationDate, setExpirationDate] = React.useState<
        Date | undefined
    >();

    useEffect(() => {
        setExpirationDate(new Date(data.expirationDate!));
    }, [])
    let initialValues = new LoanTemplateSpecification();
    const history = useHistory<any>();
    const numberHandleKeyDown = (event: any) => {
        var key = event.keyCode ? event.keyCode : event.which;

        if (!/[0-9]/.test(event.key) && key !== 8 && key !== 46) {
            event.preventDefault();
        }
    };

    const cloneTheLoanTemplateMutation = useMutation(cloneTheLoanTemplate, {
        onSuccess: (data: CloneTheLoanTemplateResponse) => {
            if (data.loanTemplateId != undefined && data.loanTemplateId != null) {
                localStorage.setItem(
                    "FinancialSupplier_ID",
                    JSON.stringify(data.loanTemplateId)
                );
                toast.success("طرح تسهیلاتی با موفقیت ثبت شد");
                history.push({
                    pathname: "/FinancialSupplier1/FinancialSupplierDetailList1/FinancialSupplierDetail",
                    state: { id: Number(data.loanTemplateId) },
                });

            }
        },
        onError: () => { },
    });

    initialValues = {
        minAmount: data?.minAmount,
        maxAmount: data?.maxAmount,
        expirationDatePersian: data?.expirationDatePersian,
        guarantorsCount: data?.guarantorsCount,
        repaymentPowerPercentage: data?.repaymentPowerPercentage,
        warrantyPercentage: data?.warrantyPercentage,
        maxLoanAmountBasedOnVehiclePricePercentage: data?.maxLoanAmountBasedOnVehiclePricePercentage,
        minAgeRestriction: data?.minAgeRestriction,
        maxAgeRestriction: data?.maxAgeRestriction,
        realProfitPercentage:data?.realProfitPercentage,
        loanTemplateId: loanTemplateId
    };

    const backClick = () => {
        history.push({
            pathname: "/FinancialSupplier1/FinancialSupplierDetailList1/FinancialSupplierDetail",
        });
    }
    return (
        <Formik
            initialValues={initialValues}
            validateOnMount={true}
            validationSchema={validationSchema}

            onSubmit={(values: any) => {
                values.minAmount = Number(
                    String(values.minAmount).replace(/,/g, "")
                );
                values.maxAmount = Number(
                    String(values.maxAmount).replace(/,/g, "")
                );
               
                values.expirationDate = expirationDate!
                    ? convertToLocalDateTime(Number(expirationDate))
                    : null;
                cloneTheLoanTemplateMutation.mutate(values);

            }}
        >
            {({ handleSubmit, handleChange, handleBlur, values, errors,
                touched }) => (
                <form onSubmit={handleSubmit}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleSubmit();
                        }
                    }}
                >
                    <div>
                        <Grid
                            container spacing={{ xs: 2, md: 3 }}
                            columns={{ xs: 4, sm: 8, md: 12 }}
                            style={{ marginLeft: '0px', width: 'fit-content' }}
                            className="suppliersListDetailContent ">
                            <span className="financialListDetailTitle" >
                                مشخصات طرح جدید
                            </span>
                            <Grid container xs={12}>
                                <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }} style={{ paddingTop: '20px' }}>
                                    <Grid item xs={6} style={{ paddingLeft: '7px' }}>
                                        <MaterialTextFieldComponent
                                            helperText={touched.loanTemplateTitle ? errors.loanTemplateTitle : ""}
                                            error={touched.loanTemplateTitle && Boolean(errors.loanTemplateTitle)}
                                            value={values.loanTemplateTitle}
                                            placeHolder={" نام طرح جدید"}
                                            label={"نام طرح جدید"}
                                            required={true}
                                            name="loanTemplateTitle"
                                            id="loanTemplateTitle"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            type="text"
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container xs={12} style={{ paddingTop: '20px' }}>
                                    <Grid container xs={8} columns={{ xs: 4, sm: 8, md: 12 }} spacing={{ xs: 1, md: 1 }}>
                                        <Grid item xs={3}>
                                            <CacheProvider value={cacheRtl}>
                                                <ThemeProvider theme={theme}>
                                                    <PriceFeildComponent
                                                        helperText={touched.minAmount ? errors.minAmount : ""}
                                                        error={touched.minAmount && Boolean(errors.minAmount)}
                                                        value={values?.minAmount!.toLocaleString()}
                                                        className="shadowTextField"
                                                        placeHolder={"کف تسهیلات (ریال)"}
                                                        label={"کف تسهیلات (ریال)"}
                                                        required={true}
                                                        name="minAmount"
                                                        id="minAmount"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        showPersianWords={false}
                                                    // onKeyDown={numberHandleKeyDown}
                                                    // type="number"
                                                    />
                                                </ThemeProvider>
                                            </CacheProvider>
                                        </Grid>

                                        <Grid item xs={3}>
                                            <CacheProvider value={cacheRtl}>
                                                <ThemeProvider theme={theme}>
                                                    <PriceFeildComponent
                                                        helperText={touched.maxAmount ? errors.maxAmount : ""}
                                                        error={touched.maxAmount && Boolean(errors.maxAmount)}
                                                        placeHolder={"سقف تسهیلات (ریال)"}
                                                        label={"سقف تسهیلات (ریال)"}
                                                        required={true}
                                                        value={values.maxAmount!.toLocaleString()}
                                                        onChange={handleChange}
                                                        name="maxAmount"
                                                        id="maxAmount"
                                                        onBlur={handleBlur}
                                                        showPersianWords={false}
                                                    // type="number"
                                                    />
                                                </ThemeProvider>
                                            </CacheProvider>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <DatePickerComponents
                                                value={expirationDate}
                                                label={"*تاریخ انقضا "}
                                                onChange={(newValue: any) => {
                                                    setExpirationDate(newValue)
                                                }}
                                                range={false}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid container xs={12} style={{ paddingTop: '20px' }}>
                                    <Grid container xs={8} columns={{ xs: 4, sm: 8, md: 12 }} spacing={{ xs: 1, md: 1 }}>
                                        <Grid item xs={3}>
                                            <MaterialTextFieldComponent
                                                helperText={touched.guarantorsCount ? errors.guarantorsCount : ""}
                                                error={touched.guarantorsCount && Boolean(errors.guarantorsCount)}
                                                value={values.guarantorsCount}
                                                placeHolder={"تعداد ضامنین"}
                                                label={"تعداد ضامنین"}
                                                required={true}
                                                name="guarantorsCount"
                                                id="guarantorsCount"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <MaterialTextFieldComponent
                                                helperText={touched.repaymentPowerPercentage ? errors.repaymentPowerPercentage : ""}
                                                error={touched.repaymentPowerPercentage && Boolean(errors.repaymentPowerPercentage)}
                                                value={values.repaymentPowerPercentage}
                                                placeHolder={"درصد توان پرداخت"}
                                                label={"درصد توان پرداخت"}
                                                required={true}
                                                name="repaymentPowerPercentage"
                                                id="repaymentPowerPercentage"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <MaterialTextFieldComponent
                                                helperText={touched.warrantyPercentage ? errors.warrantyPercentage : ""}
                                                error={touched.warrantyPercentage && Boolean(errors.warrantyPercentage)}
                                                value={values.warrantyPercentage}
                                                placeHolder={"درصد چک ضمانت"}
                                                label={"درصد چک ضمانت"}
                                                required={true}
                                                name="warrantyPercentage"
                                                id="warrantyPercentage"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <MaterialTextFieldComponent
                                                helperText={touched.maxLoanAmountBasedOnVehiclePricePercentage ? errors.maxLoanAmountBasedOnVehiclePricePercentage : ""}
                                                error={touched.maxLoanAmountBasedOnVehiclePricePercentage && Boolean(errors.maxLoanAmountBasedOnVehiclePricePercentage)}
                                                value={values.maxLoanAmountBasedOnVehiclePricePercentage}
                                                placeHolder={"درصد تسهیلات نسبت به ارزش خودرو"}
                                                label={"درصد تسهیلات نسبت به ارزش خودرو "}
                                                required={true}
                                                name="maxLoanAmountBasedOnVehiclePricePercentage"
                                                id="maxLoanAmountBasedOnVehiclePricePercentage"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                type="number"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid container xs={12} style={{ paddingTop: '20px' }}>
                                    <Grid container xs={8} columns={{ xs: 4, sm: 8, md: 12 }} spacing={{ xs: 1, md: 1 }}>
                                        <Grid item xs={3}>
                                            <MaterialTextFieldComponent
                                                helperText={touched.minAgeRestriction ? errors.minAgeRestriction : ""}
                                                error={touched.minAgeRestriction && Boolean(errors.minAgeRestriction)}
                                                value={values.minAgeRestriction}
                                                placeHolder={"کمترین سن متقاضی"}
                                                label={"کمترین سن متقاضی"}
                                                required={true}
                                                name="minAgeRestriction"
                                                id="minAgeRestriction"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <MaterialTextFieldComponent
                                                helperText={touched.maxAgeRestriction ? errors.maxAgeRestriction : ""}
                                                error={touched.maxAgeRestriction && Boolean(errors.maxAgeRestriction)}
                                                value={values.maxAgeRestriction}
                                                placeHolder={"بیشترین سن متقاضی"}
                                                label={"بیشترین سن متقاضی"}
                                                required={true}
                                                name="maxAgeRestriction"
                                                id="maxAgeRestriction"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={3}>
                                            <MaterialTextFieldComponent
                                                helperText={touched.realProfitPercentage ? errors.realProfitPercentage : ""}
                                                error={touched.realProfitPercentage && Boolean(errors.realProfitPercentage)}
                                                value={values.realProfitPercentage}
                                                placeHolder={"درصد سود واقعی تسهیلات"}
                                                label={"درصد سود واقعی تسهیلات"}
                                                required={true}
                                                name="realProfitPercentage"
                                                id="realProfitPercentage"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                type="number"
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container xs={12} columns={{ xs: 4, sm: 8, md: 12 }}>
                                <Grid item xs={8} md={8} sm={2}></Grid>
                                <Grid item xs={4} md={4} sm={12} style={{ textAlign: 'end' }}
                                >
                                    <Button
                                        type="submit"
                                        // disabled={Object.keys(errors).length > 0 && submitFlag}
                                        // className={"btnForm SuccessDefault"}
                                        disabled={Object.keys(errors).length > 0}
                                        className={`${Object.keys(errors).length > 0
                                            ? "btnForm deactivatedButton Vazirmatn "
                                            : "btnForm activatedButton Vazirmatn "
                                            }`}
                                        style={{ width: "120px", marginLeft: "1vh" }}
                                    >
                                        ثبت طرح جدید
                                    </Button>
                                    <Button
                                        className="btnForm ComingBack"
                                        style={{ width: "120px", marginLeft: "1vh" }}
                                        onClick={backClick}
                                    >
                                        انصراف
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </form>
            )}
        </Formik>
    )
}